import Header from './components/Header';
import { Ingredients } from '../../../../../pages/customize/components/Ingredients/Ingredients';
import { getPairingDataImg } from '../../utils/utils';

const MarketingCard = ({ pairingData }) => {
  // This is the "featured" pairing-card.  It is used on the foods page
  return (
    <div className={'featuredPairingCard'}>
      <div className={'topSection'}>
        <div className={'infoSection'}>
          <Header pairingData={pairingData} showRating={true} />
          <div className={'topSectionLine hr-mb-16'}></div>
          <Ingredients ingredients={pairingData.ingredients} />
        </div>
        <div
          style={{ backgroundImage: getPairingDataImg(pairingData) }}
          className={'featuredPairingImg'}
          alt={'image of food'}
        ></div>
      </div>

      <div className={'seeInstructionSection hr-extended'}>
        See Instructions
      </div>
    </div>
  );
};

export default MarketingCard;
